import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-company-agent',
	template: `


	<div class="ui container" appMargin appPadding paddingB='30'>


    <div class='ui vertical basic segment' >
        <div fxLayout="row" fxLayoutAlign='space-between center'>
            <div fxLayoutAlign='start center' fxLayout='row' fxLayoutGap='20px'>
                <div class='equipment-id'>
					<span class="sub-item">Home > Profile</span>
                    <h2 class="ui primary header">Profile</h2>
                </div>
            </div>
		</div>

<div class="ui divider"></div>
		<div fxLayout="row" fxLayoutGap='30px'>
				<div fxFlex="25%" fxLayout='column' fxLayoutGap='10px'>

					<div class="side-panel">
					<a   *ngFor="let link of projectFields" class='ui white button' fxLayout='row' routerLink='{{link.route}}' routerLinkActive='primary' appMargin marginY='8px' appPadding paddingY='14px'>
						{{link?.name}}
					</a>
					</div>
				</div>
				<div fxFlex="grow">
					<router-outlet></router-outlet>
				</div>
			</div>

</div>

	`
})
export class SettingComponent implements OnInit {
	constructor() {}
	projectFields = [ { name: 'Profile Detail', route: 'detail' }, { name: 'Setting Document', route: 'document' } ];

	ngOnInit(): void {}
}
